import { render, staticRenderFns } from "./BValidatedInputGroupFormInput.vue?vue&type=template&id=219b7156&"
import script from "./BValidatedInputGroupFormInput.vue?vue&type=script&lang=js&"
export * from "./BValidatedInputGroupFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports